import React from "react";


import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import EmailCrm from "./EmailSmtpIntegration";
import OutlookIntegration from "./OutlookIntegration";



export default function EmailContainer() {
  const navigate = useNavigate();
  const service = sessionStorage.getItem("email_service");

  if (!service) {
    return (
      <div className="p-5 text-center">
        <p>No email account connected</p>
        <Button onClick={() => navigate("/email-settings")}>
          Connect Email Account
        </Button>
      </div>
    );
  }

  if (service === "gmail") {
    return <EmailCrm />;
  }

  if (service === "outlook") {
    return <OutlookIntegration/>;
  }

  return null;
}
